import _options2 from "./options.js";
import _parse2 from "./parse.js";
import _populate2 from "./populate.js";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = stringTemplate;
var _options = _options2;
var _parse = _parse2;
var _populate = _populate2;
function stringTemplate(formatter, code, opts) {
  code = formatter.code(code);
  let metadata;
  return arg => {
    const replacements = (0, _options.normalizeReplacements)(arg);
    if (!metadata) metadata = (0, _parse.default)(formatter, code, opts);
    return formatter.unwrap((0, _populate.default)(metadata, replacements));
  };
}

//# sourceMappingURL=string.js.map
export default exports;